import { connect } from 'react-redux'

import { saveShippingAddress } from 'registry/actions'
import { setActiveModal } from '../../actions'
import { ConfirmAddressForm } from 'shared/address-forms/confirm-address-form'

const mapDispatchToProps = (dispatch, props) => {
  return {
    onConfirm: () => {
      return dispatch(
        saveShippingAddress({ ...props.enteredAddress, UserConfirmed: true })
      ).then(() => {
        dispatch(setActiveModal(null))
        PubSub.publish(BLConstants.FLASH_MESSAGE, {
          variant: 'success',
          message: 'Your shipping address has been updated!',
        })
      })
    },
  }
}

export default connect(null, mapDispatchToProps)(ConfirmAddressForm)
